import React, { FC, Fragment } from 'react';
import { Table, TableBody } from '@mui/material';

import { UserFeedFollowGroupFragment } from 'api';
import { DummyTableRow, EmptyState, IEmptyState, Loaders, ResponsiveTable } from 'components';

import * as GroupRows from './GroupRows';

const styles = {
  borderCorrection: {
    width: 'calc(100% - 2px)',
  },
} as const;

interface Props {
  groups: UserFeedFollowGroupFragment[];
  emptyStateName: keyof IEmptyState;
  isExhausted?: boolean;
  sentinelRef?: (node: Element) => void;
}

const GroupListFollow: FC<Props> = props => {
  const { emptyStateName, groups, isExhausted, sentinelRef } = props;

  if (emptyStateName && !groups.length) {
    return <EmptyState box name={emptyStateName} />;
  }

  return (
    <Fragment>
      <ResponsiveTable>
        <Table sx={styles.borderCorrection}>
          <TableBody>
            {groups.map(group => (
              <Fragment key={group.id}>
                <GroupRows.Following group={group} />
                <DummyTableRow height={16} colSpan={4} />
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </ResponsiveTable>
      {!isExhausted && (
        <div ref={sentinelRef}>
          <Loaders.Standard />
        </div>
      )}
    </Fragment>
  );
};

GroupListFollow.defaultProps = {
  isExhausted: true,
};

export default GroupListFollow;
